module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapitre Deux")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em"
    }
  }, [_vm._v("— MAT,")]), _vm._v(" ce n’est pas que je n’aime pas t’avoir ici, mais tu es bien sûr de toi ? C’est un gros pari que tu fais là. Peut-être que tu devrais prendre le vol prévu et revenir d’ici quelques mois lorsque Duarte et moi aurons remis le verger sur les rails.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mateus embrassa la joue de sa belle-sœur et glissa une main sur la légère rondeur de son ventre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Tu n’as pas quelques mois devant toi")]), _vm._v(", "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("irmãzinha")]), _vm._v(", la taquina-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle repoussa sa main.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Quatre mois seulement et Duarte et toi me traitez comme si j’étais en sucre. Je suis parfaitement capable de travailler au jardin, merci bien.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mateus pinça ses lèvres et choisit ses mots avec prudence. Il était en terrain miné et même s’il avait une bonne connaissance de la langue anglaise, il savait aussi avoir l’accent un peu cru parfois. Il lui fallait faire attention aux différences culturelles qui les séparaient. La galanterie machiste qui avait été profondément inculquée par ses parents au Portugal était plutôt mal vue par ici. Quelques semaines auparavant, lors d’une bruyante dispute après qu’il lui eut affirmé que la laisser conduire dans sa condition n’était peut-être pas la meilleure des idées, Bree avait hurlé aux aberrations du patriarcat. Ce seul souvenir le faisait encore sourire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sur le moment, il parlait surtout de l’orteil qu’elle s’était brutalement cogné et les tongs – un autre mot fabuleux qu’il avait récemment appris – cassées sur lesquelles elle venait de trébucher. Il avait été trop intimidé pour en faire la remarque.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vu que Bree avait un excellent détecteur de balivernes, il finit par lui avouer toute la vérité.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Ça ne me plaît pas que tu passes les prochains mois à te plier en deux et à te baisser pour tailler les arbres. Et puis, c’est toi ou moi le botaniste dans l’histoire ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle plissa le nez, mais ne le reprit pas. Ils savaient tous les deux que sa véritable force se trouvait dans la comptabilité. Même Duarte était complètement dépassé par l’expansion du jardin. C’était pour cette même raison que Mateus avait quitté le Portugal trois mois auparavant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il ne s’était pas attendu à tomber complètement sous le charme du Nord-ouest américain. Il savait qu’il pouvait faire s’épanouir le jardin si on lui en donnait le temps, mais son visa expirait dans une semaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Je n’ai pas envie que tu aies des problèmes, finit par dire")]), _c('i'), _vm._v("Bree. Que se passera-t-il si tu achètes ton billet et que ta petite combine ne fonctionne pas ? Alors quoi ? Un aller simple pour Lisbonne vaut bien le double de ce que tu gagnes en retour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle n’avait pas tort, mais Mateus avait parcouru la Toile de long en large pour trouver un moyen de rester au pays. Un permis de travail était sa meilleure option, mais le verger devait être solvable pour que ce soit accepté. Et il le serait… d’ici quelques mois. Tout ce qu’il avait à faire, c’était de passer la frontière canadienne et faire tamponner son passeport. De cette manière, dès qu’il atterrirait à Washington, son visa américain serait automatiquement remis à zéro pour trois mois supplémentaires. C’était infaillible.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le seul problème étant qu’il avait besoin de l’argent de son billet de retour à Lisbonne afin de payer pour son aller-retour à Vancouver.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Tu t’inquiètes trop, répliqua-t-il en écartant ses craintes. Un visa touristique, c’est une formalité. Beaucoup de gens l’ont déjà fait. Tout se passera bien.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Du moins, il l’espérait. Sinon, il ne lui restait plus qu’à retourner à son petit appartement et à son travail ennuyeux, sans les promesses d’avenir pour lesquelles il avait pris un congé sabbatique pour venir ici. C’était bien la dernière chose qu’il voulait maintenant que Duarte avait épousé Bree et qu’ils s’étaient installés aux États-Unis. Il avait espéré que Bree aurait envie de venir au Portugal, ainsi Duarte aurait pu s’occuper de l’oliveraie que leurs parents leur avaient léguée, mais Bree était dotée d’une grande famille qu’elle ne pouvait pas s’imaginer abandonner. Et tout ce qu’avait Duarte au Portugal, c’était Mateus et un petit bosquet qui ramenait à peine assez d’argent chaque année pour payer les taxes foncières.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mateus ne lui en avait pas voulu d’avoir tenté sa quête du bonheur aux États-Unis. Il voulait ce qu’il y avait de mieux pour son frère, et Bree était exactement ce qu’il lui fallait. Et lorsque d’ici cinq mois, cette petite famille s’agrandirait pour accueillir un nouveau-né, Mateus voulait à tout prix être présent. Il n’avait certainement pas envie d’être un oncle de nom seulement – il voulait être impliqué, tout comme il avait envie de l’être dans le verger. C’était sa vie à présent et tout ce dont il avait besoin, c’était d’une carte verte pour la concrétiser.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree tendit un bras vers lui et le passa autour de son torse.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Tu en as déjà tellement fait pour nous. Tu es certain que tu veux rester ? Que tu en as vraiment envie ?")]), _vm._v(" Tu ne le fais pas seulement pour Duarte et moi ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il enroula un bras autour de ses épaules tandis qu’ils prenaient le chemin de la maison. La palissade blanche semblait étinceler sous les rayons du soleil couchant, et entre ça et le léger reflet du ciel strié de lueurs rosâtres sur les fenêtres, la vue était à couper le souffle. La maison était la seule partie du jardin qui n’était pas tombée à l’abandon aux mains des anciens propriétaires. Cela prendrait quelques années pour redonner aux arbres leur splendeur d’antan, mais il y parviendrait. Cependant, vu que ni Duarte ni lui n’avait le moindre talent pour le bricolage, c’était une bonne chose que la maison ait été aussi bien entretenue.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Je le fais peut-être un tout petit peu pour vous, admit-il. Mais aussi en grande partie pour moi. Je veux une vie telle que celle que Duarte et toi construisez ici.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle renifla, amusée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Une épouse et un bébé ? Là, je sais que tu me mens.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il éclata de rire et la bouscula d’un mouvement du bassin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Eh bien, peut-être pas exactement ce que vous avez ici. Mais une charmante maison ? De la bonne terre dans laquelle je peux plonger mes mains et un terrain dont je peux faire ce qu’il me plaît ? ")]), _c('i', [_vm._v("Ç")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("a oui.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Et un jour peut-être, un mari et un bébé ? proposa-t-elle.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ce n’était pas comme s’ils n’avaient jamais parlé de cela auparavant. Il était prêt à s’installer quelque part. Il en avait envie… il n’avait simplement pas encore trouvé le bon. Ses parents avaient été loin d’être un couple parfait, mais ils avaient eu une belle vie conjugale. Et Duarte avait forgé le même lien puissant avec Bree. Comment pouvait-il espérer moins que l’amour véritable après avoir vu à quel point cela les avait tous rendus heureux ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Un jour, peut-être. On ne peut pas précipiter le destin.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree secoua la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Duarte dit la même chose.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Notre")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("avó")]), _vm._v(" Margarida avait l’habitude de nous le répéter. Surtout lorsque nous nous plaignions de choses que nous rêvions d’avoir, mais que nous ne pouvions pas nous offrir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Ah, la fameuse grand-maman. C’est aussi elle que je devrais remercier pour ces sottises qu’aime raconter Duarte à propos de l’homme « gagne-pain de la famille » et la femme, chargée de cuisine")]), _c('i', [_vm._v(" ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mateus s’esclaffa. Il en doutait. Leur avó n’avait pas été le genre de femme docile patientant sagement à la maison près de l’âtre. Duarte aurait pris beaucoup de libertés artistiques s’il les lui avait attribuées.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Je crois qu’elle aurait frappé Duarte avec le premier moule à pain à sa portée s’il avait osé dire cela devant elle.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Il lui jeta un regard en biais.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Et tu m’excuseras, mais tu serais une bien piètre boulangère.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree brûlait absolument tout ce qu’elle touchait, du coup, la cuisine était du ressort de Duarte. Mais Mateus pouvait comprendre ce que son frère avait voulu dire. Ils s’étaient tous les deux inquiétés que Bree en fasse trop. Elle paraissait déterminée à prouver que sa grossesse n’était pas incapacitante, et Mateus savait qu’elle n’avait pas tort. Mais il avait également conscience qu’elle se fatiguait bien plus rapidement qu’habituellement. Il changea de position afin qu’elle puisse s’appuyer sur lui en marchant, et elle poussa un soupir sans pourtant refuser son aide. Si elle ne le rembarrait pas, c’était qu’elle devait être sacrément épuisée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je lui en aurais bien mis une moi-même, mais je ne veux pas enseigner au bébé que la violence est la réponse à tout, répliqua-t-elle tristement. Et de toute façon, je pense que tout cela n’était qu’une simple métaphore.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Elle opina en direction de son ventre.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Tu sais, un autre genre de four.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Je n’ai jamais compris l’analogie, répondit Mateus en suivant son regard jusqu’au ventre sur lequel elle avait posé une main.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— La plupart d’entre elles ne sont pas forcément logique. Je veux dire, qui a décidé d’appeler les abdos des tablettes de chocolat ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ils atteignirent le porche et elle s’éloigna de sa douce étreinte pour aller s’effondrer sur la balancelle que Duarte et lui avaient repeinte en jaune criard le mois dernier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Quand on sait ce que le chocolat fait au corps à trop forte dose, c’est vraiment saugrenu. S’il y a bien une partie du corps qu’on devrait comparer à ça, ce ne serait certainement pas les abdos. Une partie un peu plus grasse peut-être ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mateus n’était peut-être pas attiré par les femmes, il pouvait quand même apprécier un beau corps. Et celui de Bree l’était sans le moindre doute. La grossesse l’avait davantage arrondie, bien qu’il ne s’en soit seulement rendu compte que lorsqu’elle s’en était plainte.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— Les tiens me font un peu peur,")]), _c('i'), _vm._v("dit-il, amusé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle fit légèrement rebondir sa poitrine, puis fit une grimace et croisa les bras de façon protectrice dessus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Aïe. C’est vraiment comme si j’avais mes règles en continu, marmonna-t-elle.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il rit et contracta visiblement ses pectoraux. Ayant toujours aimé le sport, il courait souvent, mais ces derniers mois de travaux manuels dans le verger lui avaient donné des muscles comme jamais auparavant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Pas de doute, les tiens sont quand même mieux")]), _vm._v(", lui concéda-t-elle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle pouffa dans un accès de hoquets qui la laissa les deux mains enroulées autour de son ventre. Ce fut dans cette position que Duarte les trouva.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Tu harcèles encore ma femme")]), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(", maninho ")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mateus lui lança un grand sourire. Avec Bree et Duarte ici, le verger lui paraissait déjà davantage un foyer que celui qu’il possédait au Portugal. Il ne lui restait désormais plus qu’à trouver un moyen de rester.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("— On ne change pas les bonnes habitudes.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28e3b754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 69
// module chunks = 0